// this file is generated by update_shopify_store_data.py at 2026-11-03 20:12:16.917027
var courses = [
    {
        "course_id": "EB42EE10-4986-EE11-9987-005056A725AD",
        "course_version": 1,
        "name": "ANA: Adult-Gerontology Primary Care Nurse Practitioner Certification (AGPCNP-BC\u00ae) PracticeIQ",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nYou will review for the AGPCNP-BC exam by quizzing yourself on over 200 practice questions covering the areas of:I. Patient Assessment ProcessII. Plan of CareIII. Professional PracticeYou may choose to go through the PracticeIQ just once or retake it as many times as you want or need. You have the option to practice with the full question set or by Content Domain area. Access is available through the learning portal 24/7.ANA's certification prep materials are developed and peer-reviewed by subject-matter experts with advanced education and certified in the specialty.",
        "learning_objectives_html": "At the conclusion, participants should be able to:\r\n<ul>\r\n    <li>Prepare for the AGPCNP-BC&reg; exam based on the ANCC Test Content Outline effective September 13, 2023.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0BB4475A-25C9-E511-8771-005056B104B1",
                "course_category_name": "Gerontology",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 23.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];